import { BidStageCheckboxSelect } from "../bid_stage/BidStageCheckboxSelect";
import { BidFilterContentProps, StyledFilterContent } from "./utils";

function StageFilterContent({ control }: BidFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Stage filter">
      <BidStageCheckboxSelect control={control} />
    </StyledFilterContent>
  );
}

export default StageFilterContent;
